var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00007 7C7.00007 4.23858 9.23864 2 12.0001 2C14.7615 2 17.0001 4.23858 17.0001 7C17.0001 9.76142 14.7615 12 12.0001 12C9.23864 12 7.00007 9.76142 7.00007 7ZM12.0001 10C10.3432 10 9.00007 8.65685 9.00007 7C9.00007 5.34315 10.3432 4 12.0001 4C13.6569 4 15.0001 5.34315 15.0001 7C15.0001 8.65685 13.6569 10 12.0001 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5829 14.5423H13.4173C15.2144 14.5423 16.8488 15.5833 17.6085 17.2119C17.9893 18.0281 18.1536 18.9285 18.0858 19.8265L18.0029 20.9247C17.9613 21.4754 18.3741 21.9556 18.9248 21.9972C19.4755 22.0387 19.9556 21.626 19.9972 21.0753L20.0801 19.9771C20.1738 18.7369 19.9468 17.4935 19.421 16.3664C18.3328 14.0335 15.9916 12.5423 13.4173 12.5423H10.5829C8.00868 12.5423 5.66753 14.0335 4.57921 16.3663C4.05336 17.4935 3.82635 18.7369 3.91999 19.9772L4.0029 21.0753C4.04448 21.626 4.52463 22.0387 5.07535 21.9972C5.62607 21.9556 6.03881 21.4754 5.99723 20.9247L5.91432 19.8266C5.84651 18.9285 6.0109 18.0281 6.39168 17.2118C7.15144 15.5833 8.78581 14.5423 10.5829 14.5423Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.202af192.svg";
export { ForwardRef as ReactComponent };